module.exports = __webpack_public_path__ + "static/media/logo.b864728e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 524
// module chunks = 0